import * as React from 'react'
import { cn } from '@/lib/utils'

interface FormActionsProps {
  /**
   * Row alignment:
   * - `end` (default) — the primary action sits bottom-right, secondary (Cancel)
   *   to its left. Use for create/edit forms; matches `DialogFooter`.
   * - `start` — left-aligned, for edit-in-place cards where a quiet Save sits by
   *   an inline "Saved." confirmation.
   */
  align?: 'end' | 'start'
  className?: string
  /** The action button(s), plus any inline status text. */
  children: React.ReactNode
}

/**
 * The standard action row for a form: consistent alignment, gap, and (by
 * convention) primary-action-last ordering. Compose this instead of hand-rolling
 * `flex justify-end` so buttons don't drift across forms. Dialogs use
 * `DialogFooter`; narrow auth cards use a full-width button — both intentional
 * and separate from this.
 */
export function FormActions({ align = 'end', className, children }: FormActionsProps) {
  return (
    <div className={cn('flex items-center gap-2', align === 'end' ? 'justify-end' : 'justify-start', className)}>
      {children}
    </div>
  )
}
